/**
 * Alle Eigenschaften der Microsoft-Graph-Ressource `user`
 * (https://learn.microsoft.com/graph/api/resources/user#properties).
 *
 * Diese Liste ist die einzige Quelle für das Profilfeld-Dropdown: Der Eigenschaftsname ist
 * Anzeige, Platzhalter im HTML (`{{givenName}}`) und `$select`-Wert für Graph. Damit bleibt
 * das Dropdown sprachunabhängig, und das Backend braucht keine eigene Feldliste – es holt
 * Werte nur für die Eigenschaften, die tatsächlich angefragt oder in einer Signatur benutzt
 * werden.
 *
 * Hinweise zu einzelnen Einträgen:
 * - Komplexe Eigenschaften (z. B. `assignedLicenses`, `employeeOrgData`) liefern keinen
 *   darstellbaren Text und bleiben beim Rendern leer.
 * - `customSecurityAttributes`, `employeeLeaveDateTime`, `mailboxSettings` und `signInActivity`
 *   brauchen zusätzliche Berechtigungen; ohne diese liefert Graph für sie keinen Wert.
 */
export const GRAPH_USER_FIELD_IDS = [
  "aboutMe",
  "accountEnabled",
  "ageGroup",
  "assignedLicenses",
  "assignedPlans",
  "birthday",
  "businessPhones",
  "city",
  "companyName",
  "consentProvidedForMinor",
  "country",
  "createdDateTime",
  "creationType",
  "customSecurityAttributes",
  "deletedDateTime",
  "department",
  "displayName",
  "employeeHireDate",
  "employeeLeaveDateTime",
  "employeeId",
  "employeeOrgData",
  "employeeType",
  "externalUserState",
  "externalUserStateChangeDateTime",
  "faxNumber",
  "givenName",
  "hireDate",
  "id",
  "identities",
  "imAddresses",
  "interests",
  "isManagementRestricted",
  "isResourceAccount",
  "jobTitle",
  "lastPasswordChangeDateTime",
  "legalAgeGroupClassification",
  "licenseAssignmentStates",
  "mail",
  "mailboxSettings",
  "mailNickname",
  "mobilePhone",
  "mySite",
  "officeLocation",
  "onPremisesDistinguishedName",
  "onPremisesDomainName",
  "onPremisesExtensionAttributes",
  "onPremisesImmutableId",
  "onPremisesLastSyncDateTime",
  "onPremisesProvisioningErrors",
  "onPremisesSamAccountName",
  "onPremisesSecurityIdentifier",
  "onPremisesSyncEnabled",
  "onPremisesUserPrincipalName",
  "otherMails",
  "passwordPolicies",
  "passwordProfile",
  "pastProjects",
  "postalCode",
  "preferredDataLocation",
  "preferredLanguage",
  "preferredName",
  "provisionedPlans",
  "proxyAddresses",
  "refreshTokensValidFromDateTime",
  "responsibilities",
  "serviceProvisioningErrors",
  "schools",
  "securityIdentifier",
  "showInAddressList",
  "signInActivity",
  "signInSessionsValidFromDateTime",
  "skills",
  "state",
  "streetAddress",
  "surname",
  "usageLocation",
  "userPrincipalName",
  "userType",
] as const;

export function graphFieldToken(property: string): string {
  return `{{${property}}}`;
}

/** Feldliste für das Dropdown: Anzeige und Platzhalter sind der Eigenschaftsname. */
export function graphUserFieldOptions(): { id: string; label: string; token: string }[] {
  return GRAPH_USER_FIELD_IDS.map((property) => ({
    id: property,
    label: property,
    token: graphFieldToken(property),
  }));
}
